function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIconDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.00001C10 8.13187 10.0391 8.26076 10.1124 8.37039C10.1856 8.48002 10.2898 8.56547 10.4116 8.61593C10.5334 8.66639 10.6674 8.67959 10.7968 8.65387C10.9261 8.62814 11.0449 8.56465 11.1381 8.47142C11.2313 8.37818 11.2948 8.25939 11.3206 8.13007C11.3463 8.00075 11.3331 7.86671 11.2826 7.74489C11.2322 7.62307 11.1467 7.51895 11.0371 7.4457C10.9275 7.37244 10.7986 7.33334 10.6667 7.33334C10.4899 7.33334 10.3203 7.40358 10.1953 7.52861C10.0703 7.65363 10 7.8232 10 8.00001ZM14.4734 7.52668L11.14 4.19334C11.0777 4.13156 11.0039 4.08267 10.9226 4.0495C10.8414 4.01632 10.7544 3.9995 10.6667 4.00001H3.33337C2.80294 4.00001 2.29423 4.21072 1.91916 4.5858C1.54409 4.96087 1.33337 5.46958 1.33337 6.00001V10C1.33337 10.5304 1.54409 11.0392 1.91916 11.4142C2.29423 11.7893 2.80294 12 3.33337 12H10.6667C10.7544 12.0005 10.8414 11.9837 10.9226 11.9505C11.0039 11.9173 11.0777 11.8685 11.14 11.8067L14.4734 8.47334C14.5359 8.41137 14.5855 8.33764 14.6193 8.2564C14.6531 8.17516 14.6706 8.08802 14.6706 8.00001C14.6706 7.912 14.6531 7.82487 14.6193 7.74363C14.5855 7.66239 14.5359 7.58865 14.4734 7.52668ZM10.3934 10.6667H3.33337C3.15656 10.6667 2.98699 10.5964 2.86197 10.4714C2.73695 10.3464 2.66671 10.1768 2.66671 10V6.00001C2.66671 5.8232 2.73695 5.65363 2.86197 5.52861C2.98699 5.40358 3.15656 5.33334 3.33337 5.33334H10.3934L13.06 8.00001L10.3934 10.6667Z",
    fill: "#2C303B",
    style: {
      fill: "#2C303B",
      fill: "color(display-p3 0.1725 0.1882 0.2314)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIconDark);
export default __webpack_public_path__ + "static/media/tag-icon-dark.0c0881b287a12abc69b1cc63116bc755.svg";
export { ForwardRef as ReactComponent };